const firebaseConfig = {
  apiKey: "AIzaSyCodEqQbbBEIORCLKTQTV_HXBvw2vQTL1w",
  authDomain: "connections-ba74f.firebaseapp.com",
  projectId: "connections-ba74f",
  storageBucket: "connections-ba74f.firebasestorage.app",
  messagingSenderId: "379965763913",
  appId: "1:379965763913:web:accfd0ecaaccfe26d4ea98",
  measurementId: "G-S2XZFZJ053",
};

export default firebaseConfig;
